import { InputAdornment, TextField } from '@mui/material';
import { Search } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

import { getClientsPageTokens } from '../getClientsPageTokens';
import { CLIENTS_PAGE_LAYOUT_SIZES } from '../clientsTokens';

export interface ClientsSearchFieldProps {
  onChange: (value: string) => void;
  placeholder: string;
  value: string;
}

export function ClientsSearchField({
  onChange,
  placeholder,
  value,
}: ClientsSearchFieldProps): JSX.Element {
  const theme = useTheme();
  const tokens = getClientsPageTokens(theme);

  const controlSx = {
    height: `${CLIENTS_PAGE_LAYOUT_SIZES.toolbarControlHeight}px`,
    borderRadius: `${CLIENTS_PAGE_LAYOUT_SIZES.toolbarFieldRadius}px`,
    bgcolor: tokens.toolbarFieldBg,
    '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
    '&:hover .MuiOutlinedInput-notchedOutline': { border: 'none' },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 'none' },
  };

  return (
    <TextField
      size="small"
      placeholder={placeholder}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      fullWidth
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <Search fontSize="small" sx={{ color: tokens.pageSubtitleColor }} />
            </InputAdornment>
          ),
        },
      }}
      sx={{
        ...controlSx,
        '& .MuiInputBase-input': {
          fontSize: '16px',
          color: tokens.filterLabelColor,
        },
      }}
    />
  );
}
